// extracted by mini-css-extract-plugin
export var details = "_ll-0";
export var inspectorPopover = "_ll-1";